<template>
    <div class="contracts top-section-spacing">
        <Header active="Contracts" />
        <TopSection heading="Create/ Manage Contracts"
                    user="J K"
                    searchLabel="description/ contact ID"
                    v-model="searchValue" />
        <v-container class="pt-2 table-container">
            <v-layout row wrap class="table-row blue py-2 px-4 cc__box-shadow relative">
                <v-flex xs2 sm1 class="pl-3">
                    <span class="white--text subheading font-weight-bold">Type</span>
                    <v-btn icon ref="sortBtn" small :class="`mt-2 sort-btn hide-on-mobile ${asc.type ? 'asc' : ''}`" @click="sortBy('type')">
                        <v-icon class="white--text title">expand_more</v-icon>
                    </v-btn>
                </v-flex>
                <v-flex class="pl-3" xs2>
                    <span class="white--text subheading font-weight-bold">Description</span>
                    <v-btn icon ref="sortBtn" small :class="`mt-2 sort-btn hide-on-mobile ${asc.description ? 'asc' : ''}`" @click="sortBy('description')">
                        <v-icon class="white--text title">expand_more</v-icon>
                    </v-btn>
                </v-flex>
                <v-flex class="pl-3" xs2>
                    <span class="white--text subheading font-weight-bold">Contract ID</span>
                    <v-btn icon ref="sortBtn" small :class="`mt-2 sort-btn hide-on-mobile ${asc.contractId ? 'asc' : ''}`" @click="sortBy('contractId')">
                        <v-icon class="white--text title">expand_more</v-icon>
                    </v-btn>
                </v-flex>
                <v-flex class="pl-3" xs1 sm2>
                    <span class="white--text subheading font-weight-bold">Licences</span>
                    <v-btn icon ref="sortBtn" small :class="`mt-2 sort-btn hide-on-mobile ${asc.totalLicences ? 'asc' : ''}`" @click="sortBy('totalLicences')">
                        <v-icon class="white--text title">expand_more</v-icon>
                    </v-btn>
                </v-flex>
                <v-flex class="pl-3" xs2>
                    <span class="white--text subheading font-weight-bold">Valid From</span>
                    <v-btn icon ref="sortBtn" small :class="`mt-2 sort-btn hide-on-mobile ${asc.startDate ? 'asc' : ''}`" @click="sortBy('startDate')">
                        <v-icon class="white--text title">expand_more</v-icon>
                    </v-btn>
                </v-flex>
                <v-flex class="pl-3" xs2>
                    <span class="white--text subheading font-weight-bold">Valid To</span>
                    <v-btn icon ref="sortBtn" small :class="`mt-2 sort-btn hide-on-mobile ${asc.endDate ? 'asc' : ''}`" @click="sortBy('endDate')">
                        <v-icon class="white--text title">expand_more</v-icon>
                    </v-btn>
                </v-flex>
                <v-flex class="pl-3" xs1 justify-center>
                    <span class="white--text subheading font-weight-bold">{{userType != 1 ? 'View' : 'Edit'}}</span>
                </v-flex>
            </v-layout>
            <simplebar scrollbarMinSize=5 data-simplebar-auto-hide="false" class="list-scroll-section">

                <div v-if="!filteredList.length || noData || error403" class="request-info">
					<div v-if="noData" class="title grey--text">No data available</div>
					<div v-if="error403" class="title grey--text">You do not have permission to view this page!</div>
					<v-progress-circular v-if="!filteredList.length && !noData && noSearchResults" :size="50" indeterminate color="blue"></v-progress-circular>
				</div>

                <div v-for="(contract, index) in filteredList" :key="`contract-${index}`" class="table-content">
                    <v-layout white row wrap class="table-row py-2 px-4">
                        <v-flex xs2 sm1 class="pl-3">
                            <span class="primary--text subheading">{{ contract.type }}</span>
                        </v-flex>
                        <v-flex class="pl-3" xs2>
                            <span class="primary--text subheading">{{  contract.description && contract.description.length > 50 ? contract.description.slice(0, 40) + " ..." : contract.description }}</span>
                        </v-flex>
                        <v-flex class="pl-3" xs2>
                            <span class="primary--text subheading">{{ contract.contractId }}</span>
                        </v-flex>
                        <v-flex class="pl-3" xs1 sm2>
                            <span class="primary--text subheading">{{ contract.currentLicences + '/' + contract.totalLicences }}</span>
                        </v-flex>
                        <v-flex class="pl-3" xs2>
                            <span class="primary--text subheading">{{ moment(String(contract.startDate)).format('DD/MM/YYYY') }}</span>
                        </v-flex>
                        <v-flex class="pl-3" xs2>
                            <span class="primary--text subheading">{{ moment(String(contract.endDate)).format('DD/MM/YYYY') }}</span>
                        </v-flex>
                        <v-flex class="pl-3" xs1 justify-center>
                            <v-btn :href="`/contract/${contract.contractId}`" flat class="blue--text text--darken-1 text-capitalize font-weight-regular subheading link">{{userType != 1 ? 'View' : 'Edit'}}</v-btn>
                        </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                </div>

            </simplebar>

            <v-btn v-if="userType == 1" :href="`/contract`" large color="blue" class="mt-4 pl-4 pr-3 text-icon-button ml-0 large-button-width">
                <span class="white--text subheading text-capitalize font-weight-bold pl-3">Add Contract</span>
                <v-icon right class="white--text title">add</v-icon>
            </v-btn>

        </v-container>
    </div>
</template>

<script>
    let asc = {
        type: false,
        description: false,
        id: false,
        licencesTotal: false,
        from: false,
        to: false
    }

    import router from "../router";
    import contractService from "../services/contract"
    import TopSection from '../components/TopSection.vue'
    import Header from '../components/Header.vue'
    import simplebar from 'simplebar-vue'
    import moment from 'moment'
    import Vue from 'vue'
    Vue.prototype.moment = moment

    export default {
        name: 'App',
        components: {
            Header, TopSection, simplebar
        },
        data() {
            const companyId = this.$route.params.id;
            sessionStorage.companyId =  companyId;
            return {
                progressBar: true,
                error403: false,
                userType: sessionStorage.userType,
                asc,
                searchValue: '',
                contracts: null,
                companyId,
                noData: false,
                noSearchResults: false
            }
        },
        methods: {
            async fetchData() {
                await contractService.getAll(this.companyId)
                .then(res => {
                    this.contracts = res;
                    if(this.contracts.data.length == 0){
                        this.noData = true;
                        this.progressBar = false;
                    }else{
                        this.progressBar = false;
                    }
                })
                .catch(err => {
                    if(err.status == 403){
                        this.error403 = true;
                        this.progressBar = false;
                    } 
                });
                
            },
            sortBy(prop) {
                this.asc[prop] = !this.asc[prop]
                if (this.contracts) {
                    if (this.asc[prop]) {
                        this.contracts.data.sort((a, b) => a[prop] < b[prop] ? -1 : 1)
                    } else {
                        this.contracts.data.sort((a, b) => a[prop] > b[prop] ? -1 : 1)
                    }
                }
            },
            checktype(obj, type) {
                return isType(obj === type)
            }
        },
        computed: {
            filteredList() {
                if (this.contracts != null) {
					this.noSearchResults = false;
                    return this.contracts.data.filter(contract => {
                        if (contract.description && contract.contractId) {
                            return contract.description.toLowerCase().includes(this.searchValue.toLowerCase()) ||
                                contract.contractId.toLocaleString().includes(this.searchValue.toLowerCase());
                        } else {
                            return contract.contractId.toLocaleString().includes(this.searchValue.toLowerCase());
                        }
                    });
                }else{
					this.noSearchResults = true;
					return [];
				}
            }
        },
        created() {
             if (sessionStorage.cctoken === undefined){
                router.push("/");
            } else {
                this.fetchData();
            }
        }
    }

</script>

<style lang="scss">
    .contracts {
        .table-container

    {
        @media (max-width: 599px) {
            padding: 0;
        }

        .flex.pl-3

    {
        @media (max-width: 599px) {
            padding-left: 2px !important;
        }
    }

    }
    }
</style>



